import { render, staticRenderFns } from "./epmsb400.vue?vue&type=template&id=22ee1f05&scoped=true"
import script from "./epmsb400.vue?vue&type=script&lang=js"
export * from "./epmsb400.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee1f05",
  null
  
)

export default component.exports